module.exports = __webpack_public_path__ + "static/img/deal_18.424d655c.png";